import {NgModule} from '@angular/core'
import {Routes, RouterModule} from '@angular/router'
import {HomeComponent} from './home/home.component'
import {DownloadComponent} from './download/download.component'
import {BrandComponent, BrandListComponent, BrandEditComponent} from './brand'
import {DashboardComponent} from './dashboard/dashboard.component'
import {NotFoundComponent} from './not-found/not-found.component'

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'brands',
    component: BrandListComponent,
  },
  {
    path: 'brand/:brandId',
    component: BrandComponent,
  },
  {
    path: 'brand/:brandId/edit',
    component: BrandEditComponent,
  },
  {
    path: 'download',
    component: DownloadComponent,
  },
  {
    path: 'download/:file',
    component: DownloadComponent,
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    redirectTo: '/404',
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/app-routing.module.ts